import React from 'react'

// query
import { useQuery } from '@apollo/client'
import { GET_EQUIPMENT_REQUEST_BY_ID_WITH_INFO } from '../../../../../graphql/equipmentRequest/equipmentRequest.queries'

// utils
import { createRequest } from './EquipmentRequestInfo.utils'

// components
import Card from '../../../../../components/cards/Card/Card.component'
import CardDataPoint from '../../../../../components/cards/CardDataPoint/CardDataPoint.component'

// icons
import { FontAwesomeIcon  } from '@fortawesome/react-fontawesome'
import { faInfo } from '@fortawesome/free-solid-svg-icons'

export default function EquipmentRequestInfo({ id }) {

    let request = {}

    const { loading, errors, data } = useQuery(GET_EQUIPMENT_REQUEST_BY_ID_WITH_INFO, {
        variables: { id }
    })

    if(data && data.equipmentRequest) {
        request = createRequest(data.equipmentRequest)
    }

    return (<Card header={{ icon: <FontAwesomeIcon icon={faInfo} size='2x' color='#707070' />, title: "Info"}}>
        <CardDataPoint label="Job" value={request.job} />
        <CardDataPoint label="Requested By" value={request.requestedBy} />
        <CardDataPoint label="Date Requested" value={request.dateRequested} />
        <CardDataPoint label="Status" value={request.status} />
        <CardDataPoint label="Truck" value={request.truck ? request.truck.number : null} />
        <CardDataPoint label="Date Fulfilled" value={request.dateFulfilled} />
    </Card>)
    
}